import React from 'react'

export default function OrdersPage() {
    return (
        <div>OrdersPage</div>
    )
}
